import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";

import { Line } from "react-chartjs-2";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { Skeleton } from "antd";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
  BarElement
);

export const options = {
  type: "line",
  responsive: true,
  
  plugins: {
    legend: {
      display: true,
      position: "top",
    },
    title: {
      display: true,
      text: "30-Day Challenge Check-in Comparison",
    },
  },
};

function getLastThirtyDays() {
  const lastThirtyDays = [];
  for (let i = 29; i >= 0; i--) {
    lastThirtyDays.push(moment().subtract(i, "days").format("DD-MM-YYYY"));
  }
  return lastThirtyDays;
}

export const UserComparisonChart = ({ user1Data, user2Data, user3Data }) => {
  const [chartData, setChartData] = useState({
    user1: [],
    user2: [],
    user3: [],
  });

  const lastThirtyDays = getLastThirtyDays();

  useEffect(() => {
    const user1Checkins = [1, 2, 3, 4, 5];
    const user2Checkins = [1, 2, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    const user3Checkins = [1, 2, 2, 3, 4, 3, 6, 8, 8, 9, 7];

    // user1Data?.forEach(({ date, count }) => {
    //     const index = lastThirtyDays.findIndex(day => day === date);
    //     if (index !== -1) {
    //         user1Checkins[index] = count;
    //     }
    // });

    // user2Data?.forEach(({ date, count }) => {
    //     const index = lastThirtyDays.findIndex(day => day === date);
    //     if (index !== -1) {
    //         user2Checkins[index] = count;
    //     }
    // });

    setChartData({
      user1: user1Checkins,
      user2: user2Checkins,
      user3: user3Checkins,
    });
  }, [user1Data, user2Data,user3Data, lastThirtyDays]);

  const lineChartData = {
    labels: lastThirtyDays,
    datasets: [
      {
        label: "User 1 Check-ins",
        data: chartData.user1,
        backgroundColor: "rgba(52, 122, 226, 0.2)",
        borderColor: "rgba(52, 122, 226, 1)",
        borderWidth: 2,
        fill: true,
        pointStyle: "circle",
        pointRadius: 5,
        pointHoverRadius: 8,
      },
      {
        label: "User 2 Check-ins",
        data: chartData.user2,
        backgroundColor: "rgba(226, 52, 78, 0.2)",
        borderColor: "rgba(226, 52, 78, 1)",
        borderWidth: 2,
        fill: true,
        pointStyle: "circle",
        pointRadius: 5,
        pointHoverRadius: 8,
      },
      {
        label: "User 3 Check-ins",
        data: chartData.user3,
        backgroundColor: "#b4fed6",
        borderColor: "#1EB564",
        borderWidth: 2,
        fill: true,
        pointStyle: "circle",
        pointRadius: 5,
        pointHoverRadius: 8,
      },

    ],
  };

  return (
    <div>
      <Line options={options} data={lineChartData} />
    </div>
  );
};

export default UserComparisonChart;
